import { IPhoneInputProps } from '../models'

export const isPropsEqual = (prev: IPhoneInputProps, next: IPhoneInputProps) =>
  prev.phoneNumberValue === next.phoneNumberValue &&
  prev.phoneCodeValue === next.phoneCodeValue &&
  prev.isDisabled === next.isDisabled &&
  prev.phoneCodeErrorMessage === next.phoneCodeErrorMessage &&
  prev.phoneNumberErrorMessage === next.phoneNumberErrorMessage &&
  JSON.stringify(prev.phoneCodeClasses) === JSON.stringify(next.phoneCodeClasses) &&
  JSON.stringify(prev.phoneNumberClasses) === JSON.stringify(next.phoneNumberClasses)
